import { dataLayerPush } from '@/shared/analytics';
import { VetRxDrawerTypes } from '@/widgets/product-details/specialty/ui/types';

export const sendAnalytics = (drawerType: VetRxDrawerTypes) => {
    if (drawerType === 'cold') {
        dataLayerPush({ event: 'view_cold_item_info_modal' });
    } else if (drawerType === 'rx_med') {
        dataLayerPush({ event: 'view_rx_info_modal' });
    }
};
